"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityDashboardPage = FacilityDashboardPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var facility_dashboard_1 = require("../components/dashboard/facility-dashboard");
var text_component_1 = require("../components/ui/text-component");
var hooks_1 = require("../store/hooks");
var client_scoped_query_1 = require("../utils/client-scoped-query");
var facility_scoped_query_1 = require("../utils/facility-scoped-query");
function FacilityDashboardPage() {
    var clientId = (0, client_scoped_query_1.useActiveClientId)();
    var facilityId = (0, facility_scoped_query_1.useActiveFacilityId)();
    var userId = (0, hooks_1.useAppSelector)(function (state) { var _a; return (_a = state.user.user) === null || _a === void 0 ? void 0 : _a._uid; });
    if (!clientId || !facilityId || !userId) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-6", children: [(0, jsx_runtime_1.jsx)(facility_dashboard_1.FacilityDashboardTitle, {}), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", className: "py-6", label: "Select a facility to view device readings." })] }));
    }
    // Keyed by facility so a switch remounts with a fresh area, window and page state instead of resetting in effects.
    return (0, jsx_runtime_1.jsx)(facility_dashboard_1.FacilityDashboardOverview, { clientId: clientId, facilityId: facilityId, userId: userId }, facilityId);
}
